import "./ReservationsScreen.css";
import { useEffect, useState } from "react";
import backIcon from "../../assets/images/back-icon.svg";
import placeholderIcon from "../../assets/images/placeholder-app-icon.svg";
import { useNavigate } from "react-router-dom";
import useWSMApi from "services/api/useWSMApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import AppLoader from "components/elements/AppLoader";
import { getWorkspaceSlotTime } from "utils/utils";
import SnackbarAlert from "components/elements/SnackbarAlert";
import CheckInAcknowledgementDialog from "components/elements/CheckInAcknowledgementDialog";

const ReservationsScreen = () => {
  const navigate = useNavigate();
  const { fetchReservations, reservationCheckIn } = useWSMApi();
  const [showCheckInDialog, setShowCheckInDialog] = useState<boolean>(false);
  const [selectedSlotData, setSelectedSlotData] = useState<any>(null);
  const [reservations, setReservations] = useState<any>(null);
  const [selectedReservation, setSelectedReservation] = useState<any>(null);

  const { data: reservationsData, isLoading } = useQuery({
    queryKey: ["get-wsm-reservations", selectedSlotData?.id],
    queryFn: () => fetchReservations(selectedSlotData?.id ?? ""),
    retry: false,
    enabled: !!selectedSlotData,
  });

  const checkInMutation = useMutation({
    mutationFn: (data: any) => reservationCheckIn(data),
    onSuccess: (updatedReservation) => {
      setReservations((prevReservations: any) =>
        prevReservations.map((reservation: any) =>
          reservation.id === updatedReservation.id
            ? updatedReservation
            : reservation,
        ),
      );
      setShowCheckInDialog(false);
    },
  });

  useEffect(() => {
    if (reservationsData?.data?.content) {
      setReservations(reservationsData.data.content);
    }
  }, [reservationsData]);

  useEffect(() => {
    const storedData = localStorage.getItem("selectedSlotData");
    if (storedData) {
      setSelectedSlotData(JSON.parse(storedData));
    }
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const checkedInUsers = reservations?.filter(
    (reservation: any) => reservation?.is_checked_in === true,
  );

  const isSlotEnded =
    selectedSlotData?.end_time &&
    new Date(selectedSlotData.end_time).getTime() < Date.now();

  const handleCheckInClick = (reservation: any) => {
    setSelectedReservation(reservation);
    setShowCheckInDialog(true);
  };

  const handleCheckInConfirmClick = () => {
    checkInMutation.mutate({ reservation_id: selectedReservation?.id });
  };

  return (
    <div className="wms-mobile-container">
      {checkInMutation?.isError ? (
        <SnackbarAlert type={"error"}>
          {checkInMutation.error.message}
        </SnackbarAlert>
      ) : (
        ""
      )}
      <div className="reservations-screen-container">
        <div className="reservations-screen-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">Reservations</div>
        </div>
        <div className="reservations-screen-detail-main-container">
          <div className="reservations-screen-detail-container">
            <div className="header-container">
              <span>
                {isSlotEnded
                  ? "Session Completed : "
                  : `${selectedSlotData?.title} `}
                {isSlotEnded ? (
                  <span style={{ color: "#C1F700", fontSize: "16px" }}>
                    {`${getWorkspaceSlotTime(
                      selectedSlotData?.start_time,
                    )} - ${getWorkspaceSlotTime(selectedSlotData?.end_time)}`}
                  </span>
                ) : (
                  <span style={{ color: "white" }}>
                    {getWorkspaceSlotTime(selectedSlotData?.start_time)}
                  </span>
                )}
              </span>
            </div>
            <div className="sub-title-container">
              <span>
                Total Checked in & Reservation : {checkedInUsers?.length ?? 0}/
                {reservations?.length ?? 0}
              </span>
            </div>
          </div>
        </div>

        {isLoading ? (
          <AppLoader />
        ) : reservations?.length > 0 ? (
          <div>
            {reservations?.map((reservation: any, index: number) => {
              return (
                <div className="reservations-screen-item-container">
                  <div className="title">{reservation?.user_name}</div>
                  <span>
                    <span className="left-margin" style={{ color: "#C1F700" }}>
                      User Type
                    </span>{" "}
                    : {reservation?.user?.type}
                  </span>
                  <span>
                    <span className="left-margin" style={{ color: "#C1F700" }}>
                      Booking ID
                    </span>{" "}
                    : {reservation?.booking_id}
                  </span>
                  <button
                    style={{
                      backgroundColor: `${
                        reservation?.is_checked_in ? "#C1F700" : "#FFFFFF"
                      }`,
                    }}
                    disabled={isSlotEnded && !reservation?.is_checked_in}
                    onClick={() => {
                      if (!reservation?.is_checked_in) {
                        handleCheckInClick(reservation);
                      }
                    }}
                  >
                    {reservation?.is_checked_in ? "Checked In" : "Check In"}
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="reservations-screen-placeholder-container">
            <img src={placeholderIcon} alt="placeholder-logo" />
            <p>No reservations</p>
          </div>
        )}
      </div>
      <CheckInAcknowledgementDialog
        open={showCheckInDialog}
        onClose={() => setShowCheckInDialog(false)}
        reservationData={selectedReservation}
        slotData={selectedSlotData}
        isLoading={checkInMutation?.isPending}
        onClickCheckIn={handleCheckInConfirmClick}
      />
    </div>
  );
};

export default ReservationsScreen;